import { render, staticRenderFns } from "./team-summary-score.vue?vue&type=template&id=d764500c&"
import script from "./team-summary-score.vue?vue&type=script&lang=js&"
export * from "./team-summary-score.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports